<template>
    <span
        v-pendo-tooltip="{ content: tooltipContent, arrow: true }"
        class="oem-product-name"
        @mouseover="onMouseover">
        {{ oemProductName }}
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { elementHasOverflow, findNodeByContent } from '@/utils/dom.utils';
import { PendoTooltip } from '@pendo/components';

export default {
    name: 'OemProductName',
    directives: {
        PendoTooltip,
    },
    data () {
        return {
            tooltipContent: null,
        };
    },
    computed: {
        ...mapGetters({
            trainingAttributes: 'subscription/trainingAttributes',
        }),
        oemProductName () {
            return this.trainingAttributes?.productName;
        },
    },
    methods: {
        onMouseover ({ currentTarget }) {
            const contentNodes = findNodeByContent(this.oemProductName, currentTarget);

            if (!contentNodes.length) {
                return;
            }

            this.tooltipContent = elementHasOverflow(contentNodes[0]) ? this.oemProductName : null;
        },
    },
};
</script>

<style lang="less" scoped>
.oem-product-name {
    font-size: 12px;
    color: var(--palette-gray-70);
    cursor: default;
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
}
</style>